import DataType from '@/util/dataType'

const BASIC_FEATURES = 'LOAN_PERSONAL_DATA, LOAN_OPERATION_DATA, LOAN_LOCK_DATA, LOAN_PAYMENT_OPTION_DATA, LOAN_STATUS_DATA'

const LOAN_FEATURES_ENUM = {
  PRE_ORIGINATION: {
    TO_BE_SIGNED: `${BASIC_FEATURES}, LOAN_SIGN_DATA`,
    TO_BE_SUBMITTED: `${BASIC_FEATURES}, LOAN_SIGN_DATA`
  },
  POST_ORIGINATION: {
    COMMON: `${BASIC_FEATURES}, LOAN_SIGN_DATA`
  },
  COLLECTION: {
    COMMON: `${BASIC_FEATURES}, LOAN_PAYMENT_PROCESS_DATA`
  }
}

const ORIGINATION_CORRECTION_SUPPORT_ROLE = [
  DataType.RoleEnum.SUPPORT_AGENT.code, DataType.RoleEnum.SUPPORT_SUPERVISOR.code, DataType.RoleEnum.SUPPORT_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.RESOLUTIONS_DEPARTMENT_AGENT.code,
  DataType.RoleEnum.ORIGINATION_AGENT.code, DataType.RoleEnum.ORIGINATION_AGENT_OUTBOUND.code, DataType.RoleEnum.ORIGINATION_SUPERVISOR.code, DataType.RoleEnum.OPERATIONS_SUPERVISOR_POC.code, DataType.RoleEnum.ORIGINATION_MANAGER.code,
  DataType.RoleEnum.CORRECTION_AGENT.code, DataType.RoleEnum.CORRECTION_SUPERVISOR.code, DataType.RoleEnum.CORRECTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
]

const APPROVED_LOAN_ROLE = [
  DataType.RoleEnum.SUPPORT_AGENT.code, DataType.RoleEnum.SUPPORT_SUPERVISOR.code, DataType.RoleEnum.SUPPORT_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.RESOLUTIONS_DEPARTMENT_AGENT.code,
  DataType.RoleEnum.ORIGINATION_AGENT.code, DataType.RoleEnum.ORIGINATION_AGENT_OUTBOUND.code, DataType.RoleEnum.ORIGINATION_SUPERVISOR.code, DataType.RoleEnum.OPERATIONS_SUPERVISOR_POC.code, DataType.RoleEnum.ORIGINATION_MANAGER.code,
  DataType.RoleEnum.CORRECTION_AGENT.code, DataType.RoleEnum.CORRECTION_SUPERVISOR.code, DataType.RoleEnum.CORRECTION_MANAGER.code, DataType.RoleEnum.RETURNING_AGENT.code, DataType.RoleEnum.RETURNING_CUSTOMER_POC.code,
  DataType.RoleEnum.RETURNING_CUSTOMER_SUPERVISOR.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
]

const PENDING_APPLICATION_ROLE = [
  DataType.RoleEnum.ORIGINATION_AGENT.code, DataType.RoleEnum.ORIGINATION_AGENT_OUTBOUND.code, DataType.RoleEnum.ORIGINATION_SUPERVISOR.code, DataType.RoleEnum.OPERATIONS_SUPERVISOR_POC.code, DataType.RoleEnum.ORIGINATION_MANAGER.code,
  DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.RETENTION_AGENT.code, DataType.RoleEnum.RETENTION_CUSTOMER_POC.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code,
  DataType.RoleEnum.RETURNING_CUSTOMER_SUPERVISOR.code, DataType.RoleEnum.RETURNING_CUSTOMER_POC.code, DataType.RoleEnum.RETURNING_AGENT.code,
  DataType.RoleEnum.COLLECTION_SUPERVISOR.code, DataType.RoleEnum.CORRECTION_AGENT.code, DataType.RoleEnum.ORIGINATION_SUPERVISOR_DISPUTE_POC.code
]

const PAYMENT_OPTION_STATUS = [
  DataType.LoanStatus.WARNING.value,
  DataType.LoanStatus.PENDING_COLLECTION.value, DataType.LoanStatus.IN_HOUSE_COLLECTION.value, DataType.LoanStatus.IN_HOUSE_REPLAN.value, DataType.LoanStatus.IN_HOUSE_SETTLEMENT.value, DataType.LoanStatus.IN_HOUSE_REJECTED.value,
  DataType.LoanStatus.PENDING_CCCS.value, DataType.LoanStatus.CCCS.value,
  DataType.LoanStatus.PENDING_BANKRUPTCY.value, DataType.LoanStatus.BANKRUPTCY.value,
  DataType.LoanStatus.MISCELLANEOUS.value
]

const BANKRUPTCY_DOCUMENTATION_REQUIRED_MAILING_PAYMENTS_STATUS = [
  DataType.LoanStatus.NEW.value, DataType.LoanStatus.GOOD_STANDING.value, DataType.LoanStatus.WARNING.value,
  DataType.LoanStatus.PENDING_COLLECTION.value, DataType.LoanStatus.IN_HOUSE_COLLECTION.value, DataType.LoanStatus.IN_HOUSE_REPLAN.value, DataType.LoanStatus.IN_HOUSE_SETTLEMENT.value, DataType.LoanStatus.IN_HOUSE_REJECTED.value,
  DataType.LoanStatus.PENDING_CCCS.value, DataType.LoanStatus.CCCS.value,
  DataType.LoanStatus.PENDING_BANKRUPTCY.value, DataType.LoanStatus.BANKRUPTCY.value,
  DataType.LoanStatus.MISCELLANEOUS.value
]

const DIC_21_STATUS = [
  DataType.LoanStatus.IN_HOUSE_COLLECTION.value, DataType.LoanStatus.IN_HOUSE_REPLAN.value, DataType.LoanStatus.IN_HOUSE_SETTLEMENT.value, DataType.LoanStatus.IN_HOUSE_REJECTED.value,
  DataType.LoanStatus.PENDING_CCCS.value, DataType.LoanStatus.CCCS.value,
  DataType.LoanStatus.PENDING_BANKRUPTCY.value, DataType.LoanStatus.BANKRUPTCY.value,
  DataType.LoanStatus.MISCELLANEOUS.value
]

const COLLECTION_STATUS = [
  DataType.LoanStatus.IN_HOUSE_COLLECTION.value, DataType.LoanStatus.IN_HOUSE_REPLAN.value, DataType.LoanStatus.IN_HOUSE_REJECTED.value,
  DataType.LoanStatus.PENDING_CCCS.value, DataType.LoanStatus.CCCS.value,
  DataType.LoanStatus.PENDING_BANKRUPTCY.value, DataType.LoanStatus.BANKRUPTCY.value,
  DataType.LoanStatus.MISCELLANEOUS.value, DataType.LoanStatus.OUT_HOUSE_COLLECTION.value, DataType.LoanStatus.PENDING_OUT_HOUSE_COLLECTION.value
]

const SystemEnum = {
  WORK_QUEUE_ENUM: {
    // pre-origination
    AGENT_REVIEW: { value: DataType.LoanStatus.AGENT_REVIEW.value, text: DataType.LoanStatus.AGENT_REVIEW.text, key: 'agentReview', features: BASIC_FEATURES },
    RETURNING: { value: DataType.LoanStatus.AGENT_REVIEW.value, text: 'returning', key: 'returning', features: BASIC_FEATURES },
    CORRECTOR_REVIEW: { value: DataType.LoanStatus.CORRECTOR_REVIEW.value, text: DataType.LoanStatus.CORRECTOR_REVIEW.text, key: 'correctorReview', features: BASIC_FEATURES },
    UNDERWRITER_REVIEW: { value: DataType.LoanStatus.UNDERWRITER_REVIEW.value, text: DataType.LoanStatus.UNDERWRITER_REVIEW.text, key: 'underwriterReview', features: `${BASIC_FEATURES}, LOAN_HANDLE_DATA` },
    TRIBE_REVIEW: { value: DataType.LoanStatus.TRIBE_REVIEW.value, text: DataType.LoanStatus.TRIBE_REVIEW.text, key: 'tribeReview', features: BASIC_FEATURES },
    POSITIVE_WITHDRAW: { value: DataType.LoanStatus.POSITIVE_WITHDRAWN.value, text: DataType.LoanStatus.POSITIVE_WITHDRAWN.text, key: 'positiveReview', features: BASIC_FEATURES },
    NEGATIVE_WITHDRAW: { value: DataType.LoanStatus.NEGATIVE_WITHDRAWN.value, text: DataType.LoanStatus.NEGATIVE_WITHDRAWN.text, key: 'negativeReview', features: BASIC_FEATURES },
    TO_BE_SIGNED: { value: [DataType.LoanStatus.AGENT_REVIEW.value, DataType.LoanStatus.CORRECTOR_REVIEW.value], text: 'To be Signed', key: 'toBeSigned', features: LOAN_FEATURES_ENUM.PRE_ORIGINATION.TO_BE_SIGNED },
    TO_BE_SUBMITTED: { value: [DataType.LoanStatus.AGENT_REVIEW.value], text: 'To Be Submitted', key: 'toBeSubmitted', features: LOAN_FEATURES_ENUM.PRE_ORIGINATION.TO_BE_SUBMITTED },
    FRAUD_WARNING: { value: [DataType.LoanStatus.CUSTOMER_REVIEW.value, DataType.LoanStatus.AGENT_REVIEW.value, DataType.LoanStatus.UNDERWRITER_REVIEW.value, DataType.LoanStatus.TRIBE_REVIEW.value, DataType.LoanStatus.CORRECTOR_REVIEW.value], text: 'Fraud Warning', key: 'fraudWarning', features: `${BASIC_FEATURES}, LOAN_FLAG_DATA` },
    SUSPECTED_LITIGANT: { value: [DataType.LoanStatus.CUSTOMER_REVIEW.value, DataType.LoanStatus.AGENT_REVIEW.value, DataType.LoanStatus.UNDERWRITER_REVIEW.value, DataType.LoanStatus.TRIBE_REVIEW.value, DataType.LoanStatus.CORRECTOR_REVIEW.value], text: 'Suspected Litigant', key: 'suspectedLitigant', features: `${BASIC_FEATURES}, LOAN_LITIGANT_DATA` },
    TRIBE_NOAA_REVIEW: { value: [DataType.LoanStatus.TRIBE_NOAA_REVIEW.value], text: 'Tribe NOAA Review', key: 'TribeNOAAReview', features: `${BASIC_FEATURES}` },
    // post-origination
    PENDING_APPROVED: { value: DataType.LoanStatus.PENDING_APPROVED.value, text: DataType.LoanStatus.PENDING_APPROVED.text, key: 'pendingApproved', features: LOAN_FEATURES_ENUM.POST_ORIGINATION.COMMON },
    APPROVED: { value: DataType.LoanStatus.APPROVED.value, text: DataType.LoanStatus.APPROVED.text, key: 'approved', features: LOAN_FEATURES_ENUM.POST_ORIGINATION.COMMON },
    NEW_LOAN: { value: DataType.LoanStatus.NEW.value, text: DataType.LoanStatus.NEW.text, key: 'new', features: LOAN_FEATURES_ENUM.POST_ORIGINATION.COMMON },
    GOOD_STANDING: { value: DataType.LoanStatus.GOOD_STANDING.value, text: DataType.LoanStatus.GOOD_STANDING.text, key: 'goodStanding', features: LOAN_FEATURES_ENUM.POST_ORIGINATION.COMMON },
    PROCESSING: { value: DataType.LoanStatus.PROCESSING.value, text: DataType.LoanStatus.PROCESSING.text, key: 'processing', features: LOAN_FEATURES_ENUM.POST_ORIGINATION.COMMON },
    WARNING: { value: DataType.LoanStatus.WARNING.value, text: DataType.LoanStatus.WARNING.text, key: 'warning', features: LOAN_FEATURES_ENUM.POST_ORIGINATION.COMMON },
    GOOD_STANDING_PAID_OFF: { value: DataType.LoanStatus.GOOD_STANDING_PAID_OFF.value, text: DataType.LoanStatus.GOOD_STANDING_PAID_OFF.text, key: 'goodStandingPaidOff', features: LOAN_FEATURES_ENUM.POST_ORIGINATION.COMMON },
    PAID_OFF: { value: DataType.LoanStatus.PAID_OFF.value, text: DataType.LoanStatus.PAID_OFF.text, key: 'paidOff', features: LOAN_FEATURES_ENUM.POST_ORIGINATION.COMMON },
    WARNING_PAID_OFF: { value: DataType.LoanStatus.WARNING_PAID_OFF.value, text: DataType.LoanStatus.WARNING_PAID_OFF.text, key: 'warningPaidOff', features: LOAN_FEATURES_ENUM.POST_ORIGINATION.COMMON },
    VOIDED_LOAN: { value: DataType.LoanStatus.VOIDED.value, text: DataType.LoanStatus.VOIDED.text, key: 'voided', features: LOAN_FEATURES_ENUM.POST_ORIGINATION.COMMON },
    // collection
    PENDING_COLLECTION: { value: DataType.LoanStatus.PENDING_COLLECTION.value, text: DataType.LoanStatus.PENDING_COLLECTION.text, key: 'pendingCollection', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    IN_HOUSE_COLLECTION: { value: DataType.LoanStatus.IN_HOUSE_COLLECTION.value, text: DataType.LoanStatus.IN_HOUSE_COLLECTION.text, key: 'inHouseCollection', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    PENDING_IN_HOUSE_APPROVE: { value: DataType.LoanStatus.PENDING_IN_HOUSE_APPROVE.value, text: DataType.LoanStatus.PENDING_IN_HOUSE_APPROVE.text, key: 'pendingApprove', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    IN_HOUSE_REPLAN: { value: DataType.LoanStatus.IN_HOUSE_REPLAN.value, text: DataType.LoanStatus.IN_HOUSE_REPLAN.text, key: 'inHouseReplan', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    IN_HOUSE_SETTLEMENT: { value: DataType.LoanStatus.IN_HOUSE_SETTLEMENT.value, text: DataType.LoanStatus.IN_HOUSE_SETTLEMENT.text, key: 'inHouseSettlement', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    PENDING_OUT_HOUSE_COLLECTION: { value: DataType.LoanStatus.PENDING_OUT_HOUSE_COLLECTION.value, text: DataType.LoanStatus.PENDING_OUT_HOUSE_COLLECTION.text, key: 'pendingOutHouse', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    OUT_HOUSE_COLLECTION: { value: DataType.LoanStatus.OUT_HOUSE_COLLECTION.value, text: DataType.LoanStatus.OUT_HOUSE_COLLECTION.text, key: 'collectionOutHouse', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    IN_HOUSE_REPLAN_PAID_OFF: { value: DataType.LoanStatus.IN_HOUSE_REPLAN_PAID_OFF.value, text: DataType.LoanStatus.IN_HOUSE_REPLAN_PAID_OFF.text, key: 'inHouseReplanPaidOff', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    IN_HOUSE_SETTLEMENT_PAID_OFF: { value: DataType.LoanStatus.IN_HOUSE_SETTLEMENT_PAID_OFF.value, text: DataType.LoanStatus.IN_HOUSE_SETTLEMENT_PAID_OFF.text, key: 'inHouseSettlementPaidOff', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    IN_HOUSE_PAID_OFF_SETTLEMENT_QUEUE: { value: DataType.LoanStatus.IN_HOUSE_PAID_OFF_SETTLEMENT_QUEUE.value, text: DataType.LoanStatus.IN_HOUSE_PAID_OFF_SETTLEMENT_QUEUE.text, key: 'inHousePaidOffSettlement', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    OUT_HOUSE_PAID_OFF: { value: DataType.LoanStatus.OUT_HOUSE_PAID_OFF.value, text: DataType.LoanStatus.OUT_HOUSE_PAID_OFF.text, key: 'outHousePaidOff', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    IN_HOUSE_REJECTED: { value: DataType.LoanStatus.IN_HOUSE_REJECTED.value, text: DataType.LoanStatus.IN_HOUSE_REJECTED.text, key: 'inHouseReject', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    BROKEN_PROMISE: { value: DataType.LoanStatus.IN_HOUSE_REJECTED.value, text: 'Broken Promise', key: 'brokenPromise', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    OUT_HOUSE_REJECTED: { value: DataType.LoanStatus.OUT_HOUSE_REJECTED.value, text: DataType.LoanStatus.OUT_HOUSE_REJECTED.text, key: 'outHouseReject', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    PENDING_BANKRUPTCY: { value: DataType.LoanStatus.PENDING_BANKRUPTCY.value, text: DataType.LoanStatus.PENDING_BANKRUPTCY.text, key: 'pendingBankruptcy', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    PENDING_CCCS: { value: DataType.LoanStatus.PENDING_CCCS.value, text: DataType.LoanStatus.PENDING_CCCS.text, key: 'pendingCccs', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    PENDING_CANCELLATION: { value: DataType.LoanStatus.PENDING_CANCELLATION.value, text: DataType.LoanStatus.PENDING_CANCELLATION.text, key: 'pendingCancellation', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    BANKRUPTCY: { value: DataType.LoanStatus.BANKRUPTCY.value, text: DataType.LoanStatus.BANKRUPTCY.text, key: 'bankruptcy', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    CCCS: { value: DataType.LoanStatus.CCCS.value, text: DataType.LoanStatus.CCCS.text, key: 'cccs', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    CANCELLATION: { value: DataType.LoanStatus.CANCELLATION.value, text: DataType.LoanStatus.CANCELLATION.text, key: 'cancellation', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON },
    MISCELLANEOUS: { value: DataType.LoanStatus.MISCELLANEOUS.value, text: DataType.LoanStatus.MISCELLANEOUS.text, key: 'miscellaneous', features: LOAN_FEATURES_ENUM.COLLECTION.COMMON }
  },
  THIRD_QUEUE_ENUM: {
    PENDING_WA: { value: DataType.LoanStatus.PENDING_OUT_HOUSE_COLLECTION.value, text: 'Pending External (WAE)', key: 'pendingWA' },
    WA: { value: DataType.LoanStatus.OUT_HOUSE_COLLECTION.value, text: 'External (WAE)', key: 'WA' },
    WA_REJECT: { value: DataType.LoanStatus.OUT_HOUSE_REJECTED.value, text: 'External Reject (WAE)', key: 'WAReject' },
    WA_PAID_OFF: { value: DataType.LoanStatus.OUT_HOUSE_PAID_OFF.value, text: 'External Paid Off (WAE)', key: 'WAPaidOff' },
    PENDING_WAI: { value: DataType.LoanStatus.PENDING_OUT_HOUSE_COLLECTION.value, text: 'Pending External (WAI)', key: 'pendingWAI' },
    WAI_POCKETED: { value: DataType.LoanStatus.OUT_HOUSE_POCKETED.value, text: 'External Pocketed', key: 'WAIPocketed' },
    WAI: { value: DataType.LoanStatus.OUT_HOUSE_COLLECTION.value, text: 'External (WAI)', key: 'WAI' },
    WAI_PAID_OFF: { value: DataType.LoanStatus.OUT_HOUSE_PAID_OFF.value, text: 'External Paid Off (WAI)', key: 'WAIPaidOff' },
    THIRD_PARTY: { value: DataType.LoanStatus.OUT_HOUSE_COLLECTION.value, text: 'External (Third Party)', key: 'ThirdParty' },
    THIRD_PARTY_PAID_OFF: { value: DataType.LoanStatus.OUT_HOUSE_PAID_OFF.value, text: 'External Paid Off (Third Party)', key: 'ThirdPartyPaidOff' },
    OUT_HOUSE_SETTLEMENT_QUEUE: { value: DataType.LoanStatus.OUT_HOUSE_SETTLEMENT_QUEUE.value, text: 'Out House Settlement', key: 'OutHouseSettlement' }
  },
  SECTION_FEATURE: {
    PERSONAL: 'personal',
    EMPLOYMENT: 'employment',
    BANK: 'bank',
    BANK_RECORDS: 'statement',
    LOAN_DETAILS: 'payment-option',
    LOAN_HISTORY: 'loan-history',
    COLLECTION_SUMMARY: 'collection-summary',
    PAYMENT_SCHEDULE: 'payment-schedule'
  },
  ROUTER_PATH: {
    PRE_ORIGINATION: { prefix: '/pre-origination/application' },
    POST_ORIGINATION: { prefix: '/post-origination/application' },
    COLLECTION: { prefix: '/collection/application' }
  },
  AUTHORIZATION_TYPE: [
    DataType.AuthorizationTypeEnum.TELEPHONE,
    DataType.AuthorizationTypeEnum.EMAIL,
    DataType.AuthorizationTypeEnum.ONLINE_CHAT,
    DataType.AuthorizationTypeEnum.OTHER
  ],
  COMMUNICATION_CHANNEL: ['Phone', 'Email', 'Others'],
  SORT_ORDER_BY: {
    CREATED_AT_DESC: { value: 1, text: 'Created At Desc', icon: 'arrow_downward' },
    CREATED_AT_ASC: { value: 2, text: 'Created At Asc', icon: 'arrow_upward' },
    UPDATED_AT_DESC: { value: 3, text: 'Updated At Desc', icon: 'arrow_downward' },
    UPDATED_AT_ASC: { value: 4, text: 'Updated At Asc', icon: 'arrow_upward' },
    SUBMITTED_AT_DESC: { value: 5, text: 'Submitted At Desc', icon: 'arrow_downward' },
    SUBMITTED_AT_ASC: { value: 6, text: 'Submitted At Asc', icon: 'arrow_upward' },
    DISBURSED_AT_DESC: { value: 7, text: 'Disbursed At Desc', icon: 'arrow_downward' },
    DISBURSED_AT_ASC: { value: 8, text: 'Disbursed At Asc', icon: 'arrow_upward' }
  },
  BOOLEAN_NUMBER: {
    TRUE: { value: 1, text: 'True' },
    FALSE: { value: -1, text: 'False' }
  },
  EMAIL_TEMPLATE_ENUM: {
    POPULAR_TEMPLATE_PAYMENT_OPTIONS: {
      text: 'Payment Options',
      templateCode: '420637800aff40258e183c330354a5da',
      pathCode: 'AL-2-1',
      statusArray: [
        DataType.LoanStatus.AGENT_REVIEW.value, DataType.LoanStatus.CORRECTOR_REVIEW.value, DataType.LoanStatus.GOOD_STANDING.value
      ],
      roleArray: [
        DataType.RoleEnum.SUPPORT_AGENT.code, DataType.RoleEnum.SUPPORT_SUPERVISOR.code, DataType.RoleEnum.SUPPORT_MANAGER.code,
        DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.RESOLUTIONS_DEPARTMENT_AGENT.code,
        DataType.RoleEnum.ORIGINATION_AGENT.code, DataType.RoleEnum.ORIGINATION_AGENT_OUTBOUND.code, DataType.RoleEnum.ORIGINATION_SUPERVISOR.code, DataType.RoleEnum.OPERATIONS_SUPERVISOR_POC.code,
        DataType.RoleEnum.ORIGINATION_MANAGER.code, DataType.RoleEnum.ORIGINATION_SUPERVISOR_DISPUTE_POC.code,
        DataType.RoleEnum.CORRECTION_AGENT.code, DataType.RoleEnum.CORRECTION_SUPERVISOR.code, DataType.RoleEnum.CORRECTION_MANAGER.code,
        DataType.RoleEnum.RETENTION_AGENT.code, DataType.RoleEnum.RETENTION_CUSTOMER_POC.code, DataType.RoleEnum.RETURNING_CUSTOMER_SUPERVISOR.code,
        DataType.RoleEnum.RETURNING_CUSTOMER_POC.code, DataType.RoleEnum.RETURNING_AGENT.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
      ]
    },
    MORE_INFORMATION_NEEDED: {
      text: 'More Information | To complete your Loan Process',
      templateCode: '4620da7917bc4dcd94ea07ebea57b6b3',
      pathCode: 'PAFU-2',
      statusArray: [
        DataType.LoanStatus.CORRECTOR_REVIEW.value
      ],
      roleArray: [
        DataType.RoleEnum.CORRECTION_AGENT.code, DataType.RoleEnum.CORRECTION_SUPERVISOR.code, DataType.RoleEnum.CORRECTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code,
        DataType.RoleEnum.RETENTION_AGENT.code, DataType.RoleEnum.RETENTION_CUSTOMER_POC.code, DataType.RoleEnum.RETURNING_AGENT.code,
        DataType.RoleEnum.RETURNING_CUSTOMER_SUPERVISOR.code, DataType.RoleEnum.RETURNING_CUSTOMER_POC.code, DataType.RoleEnum.ORIGINATION_AGENT.code, DataType.RoleEnum.ORIGINATION_AGENT_OUTBOUND.code,
        DataType.RoleEnum.ORIGINATION_SUPERVISOR.code, DataType.RoleEnum.OPERATIONS_SUPERVISOR_POC.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
      ]
    },
    FOLLOW_UP_GENERAL: {
      text: 'Follow Up',
      templateCode: '1e46095e23eb4f9e8b25b676012bcb51',
      pathCode: 'FU',
      statusArray: [
        DataType.LoanStatus.AGENT_REVIEW.value, DataType.LoanStatus.CORRECTOR_REVIEW.value, DataType.LoanStatus.NEW.value, DataType.LoanStatus.GOOD_STANDING.value
      ],
      roleArray: [
        DataType.RoleEnum.SUPPORT_AGENT.code, DataType.RoleEnum.SUPPORT_SUPERVISOR.code, DataType.RoleEnum.SUPPORT_MANAGER.code,
        DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.RESOLUTIONS_DEPARTMENT_AGENT.code, DataType.RoleEnum.RETENTION_AGENT.code,
        DataType.RoleEnum.RETENTION_CUSTOMER_POC.code, DataType.RoleEnum.RETURNING_CUSTOMER_SUPERVISOR.code, DataType.RoleEnum.COLLECTION_SUPERVISOR.code,
        DataType.RoleEnum.RETURNING_CUSTOMER_POC.code, DataType.RoleEnum.RETURNING_AGENT.code, DataType.RoleEnum.CORRECTION_AGENT.code,
        DataType.RoleEnum.ORIGINATION_SUPERVISOR_DISPUTE_POC.code, DataType.RoleEnum.OPERATIONS_SUPERVISOR_POC.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
      ]
    },
    PENDING_APPLICATION_OPTION_2: {
      text: 'Loan Application | Pending Status',
      templateCode: 'b71b9be4da9e40d2a02c03d53165b506',
      pathCode: 'PAFU-1',
      statusArray: [
        DataType.LoanStatus.AGENT_REVIEW.value, DataType.LoanStatus.CORRECTOR_REVIEW.value, DataType.LoanStatus.GOOD_STANDING.value
      ],
      roleArray: PENDING_APPLICATION_ROLE
    },
    PENDING_APPLICATION_UNABLE_TO_REACH_THE_CUSTOMER: {
      text: 'Pending Application |Unable to reach the customer',
      templateCode: 'ad4da6baff5142df89362faf96adfd02',
      pathCode: 'LAPC',
      statusArray: [
        DataType.LoanStatus.AGENT_REVIEW.value, DataType.LoanStatus.CORRECTOR_REVIEW.value
      ],
      roleArray: PENDING_APPLICATION_ROLE
    },
    SUBSEQUENT_ADVANCES_EXPLANATION: {
      text: 'Subsequent advances explanation',
      templateCode: '02bc579aa819485a8596bcbf5a8c2e87',
      pathCode: 'SA',
      statusArray: [
        DataType.LoanStatus.AGENT_REVIEW.value, DataType.LoanStatus.NEW.value, DataType.LoanStatus.GOOD_STANDING.value
      ],
      roleArray: [
        DataType.RoleEnum.SUPPORT_AGENT.code, DataType.RoleEnum.SUPPORT_SUPERVISOR.code, DataType.RoleEnum.SUPPORT_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.RESOLUTIONS_DEPARTMENT_AGENT.code,
        DataType.RoleEnum.ORIGINATION_AGENT.code, DataType.RoleEnum.ORIGINATION_AGENT_OUTBOUND.code, DataType.RoleEnum.ORIGINATION_SUPERVISOR.code, DataType.RoleEnum.OPERATIONS_SUPERVISOR_POC.code, DataType.RoleEnum.ORIGINATION_MANAGER.code,
        DataType.RoleEnum.RETENTION_AGENT.code, DataType.RoleEnum.RETENTION_CUSTOMER_POC.code, DataType.RoleEnum.RETURNING_CUSTOMER_POC.code, DataType.RoleEnum.RETURNING_CUSTOMER_SUPERVISOR.code,
        DataType.RoleEnum.RETURNING_AGENT.code, DataType.RoleEnum.ORIGINATION_SUPERVISOR_DISPUTE_POC.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
      ]
    },
    TO_BE_WITHDRAWN: {
      text: 'To Be Withdrawn',
      templateCode: '7fb8cba283714865a603d840c888520d',
      pathCode: 'AD',
      statusArray: [
        DataType.LoanStatus.POSITIVE_WITHDRAWN.value, DataType.LoanStatus.NEGATIVE_WITHDRAWN.value
      ],
      roleArray: ORIGINATION_CORRECTION_SUPPORT_ROLE
    },
    APPROVED_LOAN: {
      text: 'Approved Loan',
      templateCode: '9e87f9c91cc74f7f85b2bcad3994acd0',
      pathCode: 'AL-1',
      statusArray: [
        DataType.LoanStatus.NEW.value, DataType.LoanStatus.GOOD_STANDING.value, DataType.LoanStatus.APPROVED.value
      ],
      roleArray: APPROVED_LOAN_ROLE
    },
    ACH_REVOCATION_OPTION_1: {
      text: 'ACH Revocation',
      templateCode: 'cd2be350ced145fd8da8e941d97078a4',
      pathCode: 'ACHR-1',
      statusArray: [
        DataType.LoanStatus.NEW.value, DataType.LoanStatus.GOOD_STANDING.value, DataType.LoanStatus.PENDING_COLLECTION.value, DataType.LoanStatus.IN_HOUSE_COLLECTION.value
      ],
      roleArray: [
        DataType.RoleEnum.SUPPORT_AGENT.code, DataType.RoleEnum.SUPPORT_SUPERVISOR.code, DataType.RoleEnum.SUPPORT_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.RESOLUTIONS_DEPARTMENT_AGENT.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
      ]
    },
    CANCELED_APPLICATION: {
      text: 'Canceled Application',
      templateCode: '949c3c5b55574cb48df8b9e06c4ea7aa',
      pathCode: 'TWB-1',
      statusArray: [
        DataType.LoanStatus.POSITIVE_WITHDRAWN.value, DataType.LoanStatus.NEGATIVE_WITHDRAWN.value
      ],
      roleArray: [
        DataType.RoleEnum.SUPPORT_AGENT.code, DataType.RoleEnum.SUPPORT_SUPERVISOR.code, DataType.RoleEnum.SUPPORT_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.RESOLUTIONS_DEPARTMENT_AGENT.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
      ]
    },
    // DECLINE_LETTER_NOAA: {
    //   text: 'Decline Letter (NOAA)',
    //   templateCode: 'c5cc80d324c74465938a9ecdb5eeb6af',
    //   pathCode: 'LNA',
    //   statusArray: [
    //     DataType.LoanStatus.POSITIVE_WITHDRAWN.value, DataType.LoanStatus.NEGATIVE_WITHDRAWN.value
    //   ],
    //   roleArray: ORIGINATION_CORRECTION_SUPPORT_ROLE
    // },
    BANKRUPTCY_DOCUMENTATION_REQUIRED: {
      text: 'Bankruptcy Documentation Required',
      templateCode: '471a9e3eeb4146a2becc62bbe1e82e15',
      pathCode: 'BIN',
      statusArray: BANKRUPTCY_DOCUMENTATION_REQUIRED_MAILING_PAYMENTS_STATUS,
      roleArray: [
        DataType.RoleEnum.SUPPORT_AGENT.code, DataType.RoleEnum.SUPPORT_SUPERVISOR.code, DataType.RoleEnum.SUPPORT_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.RESOLUTIONS_DEPARTMENT_AGENT.code,
        DataType.RoleEnum.COLLECTION_AGENT.code, DataType.RoleEnum.COLLECTION_SUPERVISOR.code, DataType.RoleEnum.COLLECTION_MANAGER.code, DataType.RoleEnum.WAI_AGENT.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
      ]
    },
    MAILING_PAYMENTS: {
      text: 'Mailing Payments',
      templateCode: '58df5fbec7334192bdf10624f66e6e9a',
      pathCode: 'MP',
      statusArray: BANKRUPTCY_DOCUMENTATION_REQUIRED_MAILING_PAYMENTS_STATUS,
      roleArray: [
        DataType.RoleEnum.SUPPORT_AGENT.code, DataType.RoleEnum.SUPPORT_SUPERVISOR.code, DataType.RoleEnum.SUPPORT_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.RESOLUTIONS_DEPARTMENT_AGENT.code,
        DataType.RoleEnum.COLLECTION_AGENT.code, DataType.RoleEnum.COLLECTION_SUPERVISOR.code, DataType.RoleEnum.COLLECTION_MANAGER.code, DataType.RoleEnum.WAI_AGENT.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
      ]
    },
    PAYOFF_OPTION_1: {
      text: 'Pay Off',
      templateCode: '575ad3c7d40c4ddc9d5218d4fb2d1bf7',
      pathCode: 'PIF',
      statusArray: [
        DataType.LoanStatus.NEW.value, DataType.LoanStatus.GOOD_STANDING.value, DataType.LoanStatus.PROCESSING.value, DataType.LoanStatus.WARNING.value
      ],
      roleArray: [
        DataType.RoleEnum.SUPPORT_AGENT.code, DataType.RoleEnum.SUPPORT_SUPERVISOR.code, DataType.RoleEnum.SUPPORT_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.RESOLUTIONS_DEPARTMENT_AGENT.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
      ]
    },
    /**
     * DIC 12 -> Back on Track / Back on Track l Warning
     */
    BACK_ON_TRACK: {
      text: 'Back on Track',
      templateCode: '2b303b422ee14b7285228b4a6dfb7af1',
      pathCode: 'GBT',
      statusArray: [
        DataType.LoanStatus.IN_HOUSE_COLLECTION.value, DataType.LoanStatus.IN_HOUSE_REPLAN.value, DataType.LoanStatus.IN_HOUSE_REJECTED.value,
        DataType.LoanStatus.PENDING_CCCS.value, DataType.LoanStatus.CCCS.value, DataType.LoanStatus.IN_HOUSE_REPLAN_PAID_OFF.value,
        DataType.LoanStatus.PENDING_BANKRUPTCY.value, DataType.LoanStatus.BANKRUPTCY.value,
        DataType.LoanStatus.MISCELLANEOUS.value
      ],
      roleArray: [
        DataType.RoleEnum.COLLECTION_AGENT.code, DataType.RoleEnum.COLLECTION_SUPERVISOR.code, DataType.RoleEnum.COLLECTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.WAI_AGENT.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
      ]
    },
    BACK_ON_TRACK_WARNING: {
      text: 'Back on Track | Warning',
      templateCode: '2b303b422ee14b7285228b4a6dfb7af1',
      pathCode: 'GBT',
      statusArray: [
        DataType.LoanStatus.WARNING.value
      ],
      roleArray: [
        DataType.RoleEnum.COLLECTION_AGENT.code, DataType.RoleEnum.COLLECTION_SUPERVISOR.code, DataType.RoleEnum.COLLECTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.WAI_AGENT.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
      ]
    },
    ACKNOWLEDGEMENT_OF_ACH_REVOKE: {
      text: 'Acknowledgement of ACH revoke',
      templateCode: '7b37a0460bd64dc79744db8b7e8dc111',
      pathCode: 'ACHR-2',
      statusArray: [
        DataType.LoanStatus.NEW.value, DataType.LoanStatus.GOOD_STANDING.value, DataType.LoanStatus.WARNING.value, DataType.LoanStatus.PROCESSING.value
      ],
      roleArray: [
        DataType.RoleEnum.COLLECTION_AGENT.code, DataType.RoleEnum.COLLECTION_SUPERVISOR.code, DataType.RoleEnum.COLLECTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.WAI_AGENT.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
      ]
    },
    VALLEY_SERVICING: {
      text: 'Valley Servicing',
      templateCode: '709cb94b950a4f90b6280bbf4486c575',
      pathCode: 'IASA',
      statusArray: [
        DataType.LoanStatus.OUT_HOUSE_COLLECTION.value, DataType.LoanStatus.PENDING_OUT_HOUSE_COLLECTION.value
      ],
      roleArray: [
        DataType.RoleEnum.SUPPORT_AGENT.code, DataType.RoleEnum.SUPPORT_SUPERVISOR.code, DataType.RoleEnum.SUPPORT_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.RESOLUTIONS_DEPARTMENT_AGENT.code,
        DataType.RoleEnum.COLLECTION_AGENT.code, DataType.RoleEnum.COLLECTION_SUPERVISOR.code, DataType.RoleEnum.COLLECTION_MANAGER.code, DataType.RoleEnum.WAI_AGENT.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
      ]
    },
    PAID_OFF_CONFIRMATION: {
      text: 'Paid Off Confirmation',
      templateCode: '5fbcd65c3cd245e782be15aeeb77c410',
      pathCode: 'ACHR-3',
      statusArray: [
        DataType.LoanStatus.APPROVED.value, DataType.LoanStatus.NEW.value, DataType.LoanStatus.GOOD_STANDING.value, DataType.LoanStatus.PROCESSING.value, DataType.LoanStatus.WARNING.value, DataType.LoanStatus.GOOD_STANDING_PAID_OFF.value,
        DataType.LoanStatus.PAID_OFF.value, DataType.LoanStatus.WARNING_PAID_OFF.value, DataType.LoanStatus.VOIDED.value, DataType.LoanStatus.PENDING_APPROVED.value,
        DataType.LoanStatus.PENDING_COLLECTION.value, DataType.LoanStatus.IN_HOUSE_COLLECTION.value, DataType.LoanStatus.IN_HOUSE_REPLAN.value, DataType.LoanStatus.IN_HOUSE_SETTLEMENT.value, DataType.LoanStatus.IN_HOUSE_REJECTED.value,
        DataType.LoanStatus.IN_HOUSE_REPLAN_PAID_OFF.value,
        DataType.LoanStatus.PENDING_CCCS.value, DataType.LoanStatus.CCCS.value,
        DataType.LoanStatus.PENDING_BANKRUPTCY.value, DataType.LoanStatus.BANKRUPTCY.value,
        DataType.LoanStatus.MISCELLANEOUS.value
      ],
      roleArray: [
        DataType.RoleEnum.RETURNING_CUSTOMER_SUPERVISOR.code, DataType.RoleEnum.RETURNING_AGENT.code, DataType.RoleEnum.RETENTION_CUSTOMER_POC.code,
        DataType.RoleEnum.SUPPORT_AGENT.code, DataType.RoleEnum.SUPPORT_SUPERVISOR.code, DataType.RoleEnum.SUPPORT_MANAGER.code,
        DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.RESOLUTIONS_DEPARTMENT_AGENT.code, DataType.RoleEnum.COLLECTION_AGENT.code,
        DataType.RoleEnum.COLLECTION_SUPERVISOR.code, DataType.RoleEnum.COLLECTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code, DataType.RoleEnum.WAI_AGENT.code
      ]
    },
    PAYMENT_OPTIONS: {
      text: 'Payment Options',
      templateCode: 'f51e94bd9146442d84cf055df4f12a57',
      pathCode: 'PO',
      statusArray: PAYMENT_OPTION_STATUS,
      roleArray: [
        DataType.RoleEnum.COLLECTION_AGENT.code, DataType.RoleEnum.COLLECTION_SUPERVISOR.code, DataType.RoleEnum.COLLECTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code, DataType.RoleEnum.WAI_AGENT.code
      ]
    },
    DIC_15: {
      text: 'DIC 15',
      templateCode: 'a3359cfa3c4543ea91d1d1d8d4351eb5',
      pathCode: 'SO',
      statusArray: COLLECTION_STATUS,
      roleArray: [
        DataType.RoleEnum.COLLECTION_AGENT.code, DataType.RoleEnum.COLLECTION_SUPERVISOR.code, DataType.RoleEnum.COLLECTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code, DataType.RoleEnum.WAI_AGENT.code
      ]
    },
    DIC_21: {
      text: 'DIC 21',
      templateCode: 'fa1378a946cf4d36933b032a23333b34',
      pathCode: 'DIC',
      statusArray: DIC_21_STATUS,
      roleArray: [
        DataType.RoleEnum.COLLECTION_AGENT.code, DataType.RoleEnum.COLLECTION_SUPERVISOR.code, DataType.RoleEnum.COLLECTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code, DataType.RoleEnum.WAI_AGENT.code
      ]
    },
    BROKEN_PROMISE: {
      text: 'Broken Promise',
      templateCode: '645c3392e3a544e2bc1690e065453039',
      pathCode: 'BP',
      statusArray: COLLECTION_STATUS,
      roleArray: [
        DataType.RoleEnum.COLLECTION_AGENT.code, DataType.RoleEnum.COLLECTION_SUPERVISOR.code, DataType.RoleEnum.COLLECTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code, DataType.RoleEnum.WAI_AGENT.code
      ]
    },
    Outstanding_Balance: {
      text: 'Outstanding Balance',
      templateCode: '18e70ba15dc04f4c8d3493f0a00eb5e8',
      pathCode: 'OB',
      statusArray: DIC_21_STATUS,
      roleArray: [
        DataType.RoleEnum.COLLECTION_AGENT.code, DataType.RoleEnum.COLLECTION_SUPERVISOR.code, DataType.RoleEnum.COLLECTION_MANAGER.code, DataType.RoleEnum.PRODUCTION_MANAGER.code, DataType.RoleEnum.WAI_AGENT.code, DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code
      ]
    },
    DL_REQUEST_EMAIL: {
      text: 'DL Request Email Template',
      templateCode: 'd11cc0a873e540f6a497673b1e391365',
      pathCode: 'DL',
      statusArray: [
        DataType.LoanStatus.AGENT_REVIEW.value, DataType.LoanStatus.CORRECTOR_REVIEW.value
      ],
      roleArray: [
        DataType.RoleEnum.ORIGINATION_AGENT.code, DataType.RoleEnum.ORIGINATION_AGENT_OUTBOUND.code, DataType.RoleEnum.ORIGINATION_SUPERVISOR.code, DataType.RoleEnum.ORIGINATION_MANAGER.code,
        DataType.RoleEnum.SUPPORT_AGENT.code, DataType.RoleEnum.RETENTION_AGENT.code, DataType.RoleEnum.CHAT_AGENT.code
      ]
    }
  }
}

export default SystemEnum
